import styled from 'styled-components';

export const GrowEnvironmentToggleStyled = styled.div.attrs({
  className: 'GrowEnvironmentToggleStyled',
})`
  .Text {
    text-align: center;
  }
`;
